// 饼图与表格（代谢物分类注释，代谢物亚细胞定位）
import ChartTemplate from '../ChartTemplate';
import ChartOptionBuilder from '@/plugins/ChartOptionBuilder';

export default {
  extends: ChartTemplate,
  data () {
    return { extCPT: () => import('./ExtendComponent.vue') }
  },
  computed: {
    extCPTProps () {
      return { dataSourceParam: this.dataSourceParam, dataSource: this.dataSource }
    }
  },
  methods: {
    // initOptionAfter () {
    //   let option = { plotOptions: { pie: { point: { events: { click: this.pointClick } } } } };
    //   this.Utility.deepMerge(this.chartOption, option);
    // },

    // =============== 图表事件
    // pointClick (e) {
    //   let rowIndex = e.point.index;
    //   this.$refs.extCPT.showC2(rowIndex);
    // },

    // 扩展组件的表格行勾选事件
    onExtCPTChanged (srs) {
      let cob = new ChartOptionBuilder(this.tool.type, srs, { ...this.config, title: false }).get();
      let option = { series: cob.series };
      this.chart.update(option);
    }
  }
}